import { memo } from 'react';
import PropTypes from 'prop-types';
import { TickOutlined } from '@JohnLewisPartnership/jl-design-system/components/icons/TickOutlined';
import classnames from 'classnames';
import facetType from '../../../../utils/types/facet';
import styles from './BlockFacet.module.scss';

const BlockFacet = ({
  ariaLabel = undefined,
  disabled = false,
  mobile = false,
  showColourSwatch = false,
  value = {},
}) => (
  <div
    className={classnames(styles.container, {
      [styles.container__selected]: value.selected,
      [styles.disabled]: disabled,
    })}
    data-test-swatch={value.label.toLowerCase()}
  >
    <div className={styles.info}>
      {showColourSwatch ? (
        <span
          className={classnames(
            styles.swatch,
            styles[value.label.toLowerCase()]
          )}
        />
      ) : (
        ''
      )}

      <span aria-label={ariaLabel}>
        {value.label} ({value.quantity})
      </span>
    </div>
    {mobile && value.selected && (
      <span className={styles.tick}>
        <TickOutlined title="Selected" size="medium" />
      </span>
    )}
  </div>
);

BlockFacet.propTypes = {
  ariaLabel: PropTypes.string,
  disabled: PropTypes.bool,
  mobile: PropTypes.bool,
  showColourSwatch: PropTypes.bool,
  value: facetType,
};

export default memo(BlockFacet);
